import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import { TabType } from "@hooks/useTabs";
import { AWARDS_TAB } from "@sca/utils/constants";
import { cn } from "@util/helpers";

type SCAAwardsTabProps = {
  /** The function to change the tab state. */
  changeTab: (key: TabType) => void;
  /** The function to close the dropdown. */
  closeDropdown: () => void;
  /** The label string to get the active tab label. */
  activeLabel: string;
};

/**
 * Component to render SCA awards tabs
 */
const AwardsTab = ({
  changeTab,
  closeDropdown,
  activeLabel,
}: SCAAwardsTabProps): React.ReactElement => {
  return (
    <div
      className="absolute top-18 z-10 w-full w-full bg-white py-2 md:top-12 md:w-6/12 lg:w-4/12"
      data-testid="awards-tab-component"
    >
      {AWARDS_TAB.map(({ key, label }) => (
        <Link key={key} to={RouteFactory.scaAwards(key)}>
          <div
            onClick={() => {
              changeTab(key);
              closeDropdown();
            }}
            className={cn(
              "-mx-3 cursor-pointer px-4 py-1 text-black md:mx-0",
              { "bg-blue text-white": activeLabel === label },
              { "hover:bg-gray-200": activeLabel !== label }
            )}
          >
            {label}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default AwardsTab;
